module.exports = __webpack_public_path__ + "img/icon-warning-hex.081f28c6.svg";